// GENERATED by scripts/import-forbes.mjs from research/forbes-raw/*.json (saved manually).
// Forbes splits team value into Sport, Market, Stadium, Brand ($B). Never estimated here.
export const leagueStatus = {
  "NFL": "loaded",
  "NBA": "loaded",
  "MLB": "loaded",
  "NHL": "loaded",
  "MLS": "no-components",
  "EPL": "no-components"
}

export const forbesBreakdown = {
  "new-york-yankees": {
    "total": 8.5,
    "sport": 0.393,
    "market": 4.518,
    "stadium": 2.211,
    "brand": 1.379,
    "year": 2026,
    "month": 3,
    "revenue": 0.71,
    "operatingIncome": -0.053,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "los-angeles-dodgers": {
    "total": 7.8,
    "sport": 0.035,
    "market": 4.263,
    "stadium": 2.081,
    "brand": 1.421,
    "year": 2026,
    "month": 3,
    "revenue": 0.85,
    "operatingIncome": -0.02,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "boston-red-sox": {
    "total": 5.25,
    "sport": 0.48,
    "market": 2.631,
    "stadium": 1.298,
    "brand": 0.842,
    "year": 2026,
    "month": 3,
    "revenue": 0.567,
    "operatingIncome": 0.078,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0.0002,
    "sumOk": true,
    "componentsPublished": true
  },
  "chicago-cubs": {
    "total": 5,
    "sport": 0.457,
    "market": 2.455,
    "stadium": 1.303,
    "brand": 0.785,
    "year": 2026,
    "month": 3,
    "revenue": 0.599,
    "operatingIncome": 0.058,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "san-francisco-giants": {
    "total": 4.05,
    "sport": 0.66,
    "market": 1.746,
    "stadium": 1.091,
    "brand": 0.553,
    "year": 2026,
    "month": 3,
    "revenue": 0.477,
    "operatingIncome": 0.054,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "new-york-mets": {
    "total": 3.5,
    "sport": 0.594,
    "market": 1.476,
    "stadium": 0.864,
    "brand": 0.566,
    "year": 2026,
    "month": 3,
    "revenue": 0.553,
    "operatingIncome": -0.213,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "philadelphia-phillies": {
    "total": 3.4,
    "sport": 0.598,
    "market": 1.553,
    "stadium": 0.763,
    "brand": 0.486,
    "year": 2026,
    "month": 3,
    "revenue": 0.539,
    "operatingIncome": -0.052,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "atlanta-braves": {
    "total": 3.35,
    "sport": 0.424,
    "market": 1.432,
    "stadium": 1.014,
    "brand": 0.479,
    "year": 2026,
    "month": 3,
    "revenue": 0.524,
    "operatingIncome": 0.027,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": -0.0003,
    "sumOk": true,
    "componentsPublished": true
  },
  "houston-astros": {
    "total": 3.2,
    "sport": 0.461,
    "market": 1.298,
    "stadium": 1.013,
    "brand": 0.428,
    "year": 2026,
    "month": 3,
    "revenue": 0.464,
    "operatingIncome": -0.045,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "san-diego-padres": {
    "total": 3.1,
    "sport": 0.72,
    "market": 1.104,
    "stadium": 0.91,
    "brand": 0.366,
    "year": 2026,
    "month": 3,
    "revenue": 0.452,
    "operatingIncome": -0.0013,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "los-angeles-angels": {
    "total": 2.8,
    "sport": 0.645,
    "market": 1.254,
    "stadium": 0.568,
    "brand": 0.332,
    "year": 2026,
    "month": 3,
    "revenue": 0.377,
    "operatingIncome": -0.014,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": -0.0004,
    "sumOk": true,
    "componentsPublished": true
  },
  "st-louis-cardinals": {
    "total": 2.75,
    "sport": 0.856,
    "market": 1.021,
    "stadium": 0.517,
    "brand": 0.356,
    "year": 2026,
    "month": 3,
    "revenue": 0.35,
    "operatingIncome": 0.033,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "texas-rangers": {
    "total": 2.7,
    "sport": 0.712,
    "market": 1.047,
    "stadium": 0.565,
    "brand": 0.375,
    "year": 2026,
    "month": 3,
    "revenue": 0.398,
    "operatingIncome": -0.044,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": -0.0004,
    "sumOk": true,
    "componentsPublished": true
  },
  "toronto-blue-jays": {
    "total": 2.5,
    "sport": 0.645,
    "market": 0.935,
    "stadium": 0.629,
    "brand": 0.291,
    "year": 2026,
    "month": 3,
    "revenue": 0.445,
    "operatingIncome": -0.071,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "seattle-mariners": {
    "total": 2.35,
    "sport": 0.74,
    "market": 0.889,
    "stadium": 0.452,
    "brand": 0.269,
    "year": 2026,
    "month": 3,
    "revenue": 0.39,
    "operatingIncome": 0.024,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "washington-nationals": {
    "total": 2.15,
    "sport": 0.622,
    "market": 0.867,
    "stadium": 0.429,
    "brand": 0.233,
    "year": 2026,
    "month": 3,
    "revenue": 0.3,
    "operatingIncome": -0.015,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0.0005,
    "sumOk": true,
    "componentsPublished": true
  },
  "baltimore-orioles": {
    "total": 2.1,
    "sport": 0.916,
    "market": 0.706,
    "stadium": 0.273,
    "brand": 0.206,
    "year": 2026,
    "month": 3,
    "revenue": 0.355,
    "operatingIncome": 0.023,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0.0005,
    "sumOk": true,
    "componentsPublished": true
  },
  "oakland-athletics": {
    "total": 2,
    "sport": 1.018,
    "market": 0.603,
    "stadium": 0.227,
    "brand": 0.153,
    "year": 2026,
    "month": 3,
    "revenue": 0.32,
    "operatingIncome": 0.045,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0.0005,
    "sumOk": true,
    "componentsPublished": true
  },
  "arizona-diamondbacks": {
    "total": 1.96,
    "sport": 0.84,
    "market": 0.597,
    "stadium": 0.352,
    "brand": 0.171,
    "year": 2026,
    "month": 3,
    "revenue": 0.324,
    "operatingIncome": -0.031,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "chicago-white-sox": {
    "total": 1.94,
    "sport": 0.933,
    "market": 0.528,
    "stadium": 0.308,
    "brand": 0.171,
    "year": 2026,
    "month": 3,
    "revenue": 0.239,
    "operatingIncome": -0.04,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "milwaukee-brewers": {
    "total": 1.9,
    "sport": 0.751,
    "market": 0.583,
    "stadium": 0.376,
    "brand": 0.19,
    "year": 2026,
    "month": 3,
    "revenue": 0.354,
    "operatingIncome": 0.047,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "detroit-tigers": {
    "total": 1.8,
    "sport": 0.749,
    "market": 0.564,
    "stadium": 0.304,
    "brand": 0.184,
    "year": 2026,
    "month": 3,
    "revenue": 0.363,
    "operatingIncome": 0.027,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0.0006,
    "sumOk": true,
    "componentsPublished": true
  },
  "minnesota-twins": {
    "total": 1.71,
    "sport": 0.814,
    "market": 0.48,
    "stadium": 0.265,
    "brand": 0.151,
    "year": 2026,
    "month": 3,
    "revenue": 0.315,
    "operatingIncome": 0.011,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "tampa-bay-rays": {
    "total": 1.7,
    "sport": 0.995,
    "market": 0.423,
    "stadium": 0.144,
    "brand": 0.139,
    "year": 2026,
    "month": 3,
    "revenue": 0.29,
    "operatingIncome": 0.031,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0.0006,
    "sumOk": true,
    "componentsPublished": true
  },
  "colorado-rockies": {
    "total": 1.68,
    "sport": 0.705,
    "market": 0.519,
    "stadium": 0.307,
    "brand": 0.149,
    "year": 2026,
    "month": 3,
    "revenue": 0.319,
    "operatingIncome": 0.02,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "cleveland-guardians": {
    "total": 1.66,
    "sport": 0.713,
    "market": 0.509,
    "stadium": 0.261,
    "brand": 0.177,
    "year": 2026,
    "month": 3,
    "revenue": 0.337,
    "operatingIncome": 0.053,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "kansas-city-royals": {
    "total": 1.64,
    "sport": 0.786,
    "market": 0.445,
    "stadium": 0.272,
    "brand": 0.138,
    "year": 2026,
    "month": 3,
    "revenue": 0.33,
    "operatingIncome": 0.025,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0.0006,
    "sumOk": true,
    "componentsPublished": true
  },
  "pittsburgh-pirates": {
    "total": 1.62,
    "sport": 0.77,
    "market": 0.517,
    "stadium": 0.181,
    "brand": 0.152,
    "year": 2026,
    "month": 3,
    "revenue": 0.33,
    "operatingIncome": 0.048,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "cincinnati-reds": {
    "total": 1.6,
    "sport": 0.738,
    "market": 0.453,
    "stadium": 0.268,
    "brand": 0.141,
    "year": 2026,
    "month": 3,
    "revenue": 0.336,
    "operatingIncome": 0.026,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "miami-marlins": {
    "total": 1.5,
    "sport": 0.82,
    "market": 0.358,
    "stadium": 0.182,
    "brand": 0.141,
    "year": 2026,
    "month": 3,
    "revenue": 0.32,
    "operatingIncome": 0.053,
    "source": "Forbes mlb-valuations 2026",
    "sumCheck": 0.0007,
    "sumOk": true,
    "componentsPublished": true
  },
  "golden-state-warriors": {
    "total": 11,
    "sport": 1.702,
    "market": 4.224,
    "stadium": 3.709,
    "brand": 1.366,
    "year": 2025,
    "month": 10,
    "revenue": 0.88,
    "operatingIncome": 0.409,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "los-angeles-lakers": {
    "total": 10,
    "sport": 2.436,
    "market": 4.611,
    "stadium": 1.403,
    "brand": 1.549,
    "year": 2025,
    "month": 10,
    "revenue": 0.551,
    "operatingIncome": 0.17,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": -0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "new-york-knicks": {
    "total": 9.75,
    "sport": 2.312,
    "market": 4.161,
    "stadium": 1.865,
    "brand": 1.412,
    "year": 2025,
    "month": 10,
    "revenue": 0.532,
    "operatingIncome": 0.098,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "los-angeles-clippers": {
    "total": 7.5,
    "sport": 2.058,
    "market": 2.517,
    "stadium": 2.043,
    "brand": 0.883,
    "year": 2025,
    "month": 10,
    "revenue": 0.569,
    "operatingIncome": 0.154,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "boston-celtics": {
    "total": 6.7,
    "sport": 2.39,
    "market": 2.377,
    "stadium": 1.098,
    "brand": 0.835,
    "year": 2025,
    "month": 10,
    "revenue": 0.458,
    "operatingIncome": 0.116,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "chicago-bulls": {
    "total": 6,
    "sport": 2.215,
    "market": 1.812,
    "stadium": 1.391,
    "brand": 0.581,
    "year": 2025,
    "month": 10,
    "revenue": 0.434,
    "operatingIncome": 0.16,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": -0.0002,
    "sumOk": true,
    "componentsPublished": true
  },
  "houston-rockets": {
    "total": 5.9,
    "sport": 2.113,
    "market": 1.785,
    "stadium": 1.439,
    "brand": 0.563,
    "year": 2025,
    "month": 10,
    "revenue": 0.467,
    "operatingIncome": 0.191,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "miami-heat": {
    "total": 5.7,
    "sport": 2.232,
    "market": 1.58,
    "stadium": 1.35,
    "brand": 0.537,
    "year": 2025,
    "month": 10,
    "revenue": 0.417,
    "operatingIncome": 0.11,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": -0.0002,
    "sumOk": true,
    "componentsPublished": true
  },
  "brooklyn-nets": {
    "total": 5.6,
    "sport": 2.245,
    "market": 1.492,
    "stadium": 1.371,
    "brand": 0.492,
    "year": 2025,
    "month": 10,
    "revenue": 0.402,
    "operatingIncome": 0.05,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "philadelphia-76ers": {
    "total": 5.45,
    "sport": 1.85,
    "market": 1.709,
    "stadium": 1.254,
    "brand": 0.637,
    "year": 2025,
    "month": 10,
    "revenue": 0.472,
    "operatingIncome": 0.203,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "phoenix-suns": {
    "total": 5.425,
    "sport": 2.197,
    "market": 1.379,
    "stadium": 1.307,
    "brand": 0.541,
    "year": 2025,
    "month": 10,
    "revenue": 0.455,
    "operatingIncome": -0.033,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": -0.0002,
    "sumOk": true,
    "componentsPublished": true
  },
  "toronto-raptors": {
    "total": 5.4,
    "sport": 2.306,
    "market": 1.222,
    "stadium": 1.387,
    "brand": 0.484,
    "year": 2025,
    "month": 10,
    "revenue": 0.38,
    "operatingIncome": 0.136,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": -0.0002,
    "sumOk": true,
    "componentsPublished": true
  },
  "dallas-mavericks": {
    "total": 5.1,
    "sport": 1.995,
    "market": 1.43,
    "stadium": 1.159,
    "brand": 0.516,
    "year": 2025,
    "month": 10,
    "revenue": 0.407,
    "operatingIncome": 0.087,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "atlanta-hawks": {
    "total": 5,
    "sport": 1.992,
    "market": 1.089,
    "stadium": 1.529,
    "brand": 0.391,
    "year": 2025,
    "month": 10,
    "revenue": 0.477,
    "operatingIncome": 0.203,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0.0002,
    "sumOk": true,
    "componentsPublished": true
  },
  "cleveland-cavaliers": {
    "total": 4.8,
    "sport": 1.902,
    "market": 1.442,
    "stadium": 0.924,
    "brand": 0.532,
    "year": 2025,
    "month": 10,
    "revenue": 0.44,
    "operatingIncome": 0.127,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "washington-wizards": {
    "total": 4.7,
    "sport": 2.13,
    "market": 1.232,
    "stadium": 0.942,
    "brand": 0.396,
    "year": 2025,
    "month": 10,
    "revenue": 0.389,
    "operatingIncome": 0.135,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "denver-nuggets": {
    "total": 4.6,
    "sport": 2.429,
    "market": 1.013,
    "stadium": 0.757,
    "brand": 0.401,
    "year": 2025,
    "month": 10,
    "revenue": 0.364,
    "operatingIncome": 0.067,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "sacramento-kings": {
    "total": 4.45,
    "sport": 2.062,
    "market": 1.051,
    "stadium": 0.942,
    "brand": 0.396,
    "year": 2025,
    "month": 10,
    "revenue": 0.354,
    "operatingIncome": 0.075,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0.0002,
    "sumOk": true,
    "componentsPublished": true
  },
  "san-antonio-spurs": {
    "total": 4.4,
    "sport": 2,
    "market": 1.078,
    "stadium": 0.957,
    "brand": 0.365,
    "year": 2025,
    "month": 10,
    "revenue": 0.401,
    "operatingIncome": 0.151,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "oklahoma-city-thunder": {
    "total": 4.35,
    "sport": 2.331,
    "market": 1.04,
    "stadium": 0.573,
    "brand": 0.406,
    "year": 2025,
    "month": 10,
    "revenue": 0.357,
    "operatingIncome": 0.114,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "milwaukee-bucks": {
    "total": 4.3,
    "sport": 2.187,
    "market": 1.068,
    "stadium": 0.626,
    "brand": 0.419,
    "year": 2025,
    "month": 10,
    "revenue": 0.355,
    "operatingIncome": 0.026,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "portland-trail-blazers": {
    "total": 4.25,
    "sport": 2.264,
    "market": 0.888,
    "stadium": 0.767,
    "brand": 0.331,
    "year": 2025,
    "month": 10,
    "revenue": 0.361,
    "operatingIncome": 0.111,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "indiana-pacers": {
    "total": 4.2,
    "sport": 2.382,
    "market": 0.852,
    "stadium": 0.648,
    "brand": 0.318,
    "year": 2025,
    "month": 10,
    "revenue": 0.342,
    "operatingIncome": 0.089,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "utah-jazz": {
    "total": 4.1,
    "sport": 2.152,
    "market": 0.858,
    "stadium": 0.773,
    "brand": 0.317,
    "year": 2025,
    "month": 10,
    "revenue": 0.34,
    "operatingIncome": 0.103,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "orlando-magic": {
    "total": 3.9,
    "sport": 2.324,
    "market": 0.843,
    "stadium": 0.417,
    "brand": 0.316,
    "year": 2025,
    "month": 10,
    "revenue": 0.318,
    "operatingIncome": 0.094,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "charlotte-hornets": {
    "total": 3.8,
    "sport": 2.294,
    "market": 0.679,
    "stadium": 0.608,
    "brand": 0.219,
    "year": 2025,
    "month": 10,
    "revenue": 0.328,
    "operatingIncome": 0.081,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "detroit-pistons": {
    "total": 3.65,
    "sport": 2.104,
    "market": 0.894,
    "stadium": 0.375,
    "brand": 0.277,
    "year": 2025,
    "month": 10,
    "revenue": 0.321,
    "operatingIncome": 0.106,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "minnesota-timberwolves": {
    "total": 3.6,
    "sport": 2.15,
    "market": 0.788,
    "stadium": 0.374,
    "brand": 0.288,
    "year": 2025,
    "month": 10,
    "revenue": 0.32,
    "operatingIncome": -0.041,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "new-orleans-pelicans": {
    "total": 3.55,
    "sport": 2.306,
    "market": 0.618,
    "stadium": 0.379,
    "brand": 0.247,
    "year": 2025,
    "month": 10,
    "revenue": 0.302,
    "operatingIncome": 0.077,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "memphis-grizzlies": {
    "total": 3.5,
    "sport": 2.303,
    "market": 0.658,
    "stadium": 0.323,
    "brand": 0.216,
    "year": 2025,
    "month": 10,
    "revenue": 0.306,
    "operatingIncome": 0.028,
    "source": "Forbes nba-valuations 2025",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "dallas-cowboys": {
    "total": 17,
    "sport": 6.713,
    "market": 3.788,
    "stadium": 3.246,
    "brand": 3.253,
    "year": 2026,
    "month": 9,
    "revenue": 1.278,
    "operatingIncome": 0.677,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "los-angeles-rams": {
    "total": 13.5,
    "sport": 7.07,
    "market": 1.944,
    "stadium": 3.587,
    "brand": 0.899,
    "year": 2026,
    "month": 9,
    "revenue": 0.898,
    "operatingIncome": 0.335,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "new-york-giants": {
    "total": 12,
    "sport": 7.342,
    "market": 1.792,
    "stadium": 2.04,
    "brand": 0.826,
    "year": 2026,
    "month": 9,
    "revenue": 0.769,
    "operatingIncome": 0.181,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "new-england-patriots": {
    "total": 10.6,
    "sport": 6.358,
    "market": 1.67,
    "stadium": 1.551,
    "brand": 1.021,
    "year": 2026,
    "month": 9,
    "revenue": 0.784,
    "operatingIncome": 0.186,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "san-francisco-49ers": {
    "total": 10.5,
    "sport": 6.568,
    "market": 1.862,
    "stadium": 1.35,
    "brand": 0.719,
    "year": 2026,
    "month": 9,
    "revenue": 0.752,
    "operatingIncome": 0.126,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": -0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "miami-dolphins": {
    "total": 10.4,
    "sport": 6.035,
    "market": 1.161,
    "stadium": 2.714,
    "brand": 0.489,
    "year": 2026,
    "month": 9,
    "revenue": 0.81,
    "operatingIncome": 0.198,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": -0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "new-york-jets": {
    "total": 10.35,
    "sport": 6.796,
    "market": 1.361,
    "stadium": 1.658,
    "brand": 0.535,
    "year": 2026,
    "month": 9,
    "revenue": 0.716,
    "operatingIncome": 0.216,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "las-vegas-raiders": {
    "total": 10.3,
    "sport": 5.425,
    "market": 1.397,
    "stadium": 2.793,
    "brand": 0.684,
    "year": 2026,
    "month": 9,
    "revenue": 0.887,
    "operatingIncome": 0.191,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": -0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "philadelphia-eagles": {
    "total": 10.25,
    "sport": 6.761,
    "market": 1.464,
    "stadium": 1.346,
    "brand": 0.679,
    "year": 2026,
    "month": 9,
    "revenue": 0.713,
    "operatingIncome": 0.154,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "atlanta-falcons": {
    "total": 10.1,
    "sport": 5.898,
    "market": 1.036,
    "stadium": 2.625,
    "brand": 0.541,
    "year": 2026,
    "month": 9,
    "revenue": 0.805,
    "operatingIncome": 0.24,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "washington-commanders": {
    "total": 9.8,
    "sport": 6.641,
    "market": 1.292,
    "stadium": 1.351,
    "brand": 0.515,
    "year": 2026,
    "month": 9,
    "revenue": 0.694,
    "operatingIncome": 0.121,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": -0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "chicago-bears": {
    "total": 9.7,
    "sport": 6.953,
    "market": 1.344,
    "stadium": 0.877,
    "brand": 0.526,
    "year": 2026,
    "month": 9,
    "revenue": 0.656,
    "operatingIncome": 0.073,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "houston-texans": {
    "total": 9.65,
    "sport": 6.288,
    "market": 1.511,
    "stadium": 1.218,
    "brand": 0.633,
    "year": 2026,
    "month": 9,
    "revenue": 0.722,
    "operatingIncome": 0.16,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "seattle-seahawks": {
    "total": 9.6,
    "sport": 6.851,
    "market": 1.174,
    "stadium": 0.997,
    "brand": 0.578,
    "year": 2026,
    "month": 9,
    "revenue": 0.659,
    "operatingIncome": 0.13,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "denver-broncos": {
    "total": 9.4,
    "sport": 6.356,
    "market": 1.457,
    "stadium": 0.937,
    "brand": 0.651,
    "year": 2026,
    "month": 9,
    "revenue": 0.695,
    "operatingIncome": 0.097,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "tampa-bay-buccaneers": {
    "total": 9.1,
    "sport": 6.518,
    "market": 1.152,
    "stadium": 1.032,
    "brand": 0.397,
    "year": 2026,
    "month": 9,
    "revenue": 0.657,
    "operatingIncome": 0.095,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": -0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "cleveland-browns": {
    "total": 9,
    "sport": 5.881,
    "market": 1.454,
    "stadium": 1.091,
    "brand": 0.574,
    "year": 2026,
    "month": 9,
    "revenue": 0.72,
    "operatingIncome": 0.11,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "kansas-city-chiefs": {
    "total": 8.8,
    "sport": 6.423,
    "market": 1.026,
    "stadium": 0.873,
    "brand": 0.479,
    "year": 2026,
    "month": 9,
    "revenue": 0.644,
    "operatingIncome": 0.051,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "pittsburgh-steelers": {
    "total": 8.7,
    "sport": 6.266,
    "market": 1.028,
    "stadium": 0.867,
    "brand": 0.539,
    "year": 2026,
    "month": 9,
    "revenue": 0.653,
    "operatingIncome": 0.074,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "green-bay-packers": {
    "total": 8.6,
    "sport": 5.373,
    "market": 1.338,
    "stadium": 1.075,
    "brand": 0.814,
    "year": 2026,
    "month": 9,
    "revenue": 0.753,
    "operatingIncome": 0.073,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "tennessee-titans": {
    "total": 8.5,
    "sport": 6.583,
    "market": 0.877,
    "stadium": 0.732,
    "brand": 0.308,
    "year": 2026,
    "month": 9,
    "revenue": 0.607,
    "operatingIncome": 0.085,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "los-angeles-chargers": {
    "total": 8.3,
    "sport": 6.27,
    "market": 0.933,
    "stadium": 0.755,
    "brand": 0.342,
    "year": 2026,
    "month": 9,
    "revenue": 0.623,
    "operatingIncome": 0.057,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "minnesota-vikings": {
    "total": 8.25,
    "sport": 6.06,
    "market": 1.015,
    "stadium": 0.728,
    "brand": 0.446,
    "year": 2026,
    "month": 9,
    "revenue": 0.64,
    "operatingIncome": 0.025,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": -0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "baltimore-ravens": {
    "total": 8.2,
    "sport": 5.88,
    "market": 1.035,
    "stadium": 0.835,
    "brand": 0.449,
    "year": 2026,
    "month": 9,
    "revenue": 0.656,
    "operatingIncome": 0.077,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": -0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "buffalo-bills": {
    "total": 8.15,
    "sport": 6.216,
    "market": 0.88,
    "stadium": 0.674,
    "brand": 0.38,
    "year": 2026,
    "month": 9,
    "revenue": 0.617,
    "operatingIncome": 0.058,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "carolina-panthers": {
    "total": 8.1,
    "sport": 5.89,
    "market": 0.953,
    "stadium": 0.884,
    "brand": 0.373,
    "year": 2026,
    "month": 9,
    "revenue": 0.646,
    "operatingIncome": 0.088,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "indianapolis-colts": {
    "total": 8.08,
    "sport": 6.072,
    "market": 0.925,
    "stadium": 0.673,
    "brand": 0.411,
    "year": 2026,
    "month": 9,
    "revenue": 0.626,
    "operatingIncome": 0.081,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "arizona-cardinals": {
    "total": 8.06,
    "sport": 6.317,
    "market": 0.795,
    "stadium": 0.566,
    "brand": 0.382,
    "year": 2026,
    "month": 9,
    "revenue": 0.6,
    "operatingIncome": 0.119,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "jacksonville-jaguars": {
    "total": 8.05,
    "sport": 6.403,
    "market": 0.658,
    "stadium": 0.606,
    "brand": 0.384,
    "year": 2026,
    "month": 9,
    "revenue": 0.591,
    "operatingIncome": 0.031,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "detroit-lions": {
    "total": 8.04,
    "sport": 6.127,
    "market": 0.882,
    "stadium": 0.619,
    "brand": 0.411,
    "year": 2026,
    "month": 9,
    "revenue": 0.617,
    "operatingIncome": 0.053,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": -0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "new-orleans-saints": {
    "total": 8.02,
    "sport": 5.872,
    "market": 0.895,
    "stadium": 0.914,
    "brand": 0.34,
    "year": 2026,
    "month": 9,
    "revenue": 0.642,
    "operatingIncome": 0.165,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0.0001,
    "sumOk": true,
    "componentsPublished": true
  },
  "cincinnati-bengals": {
    "total": 8,
    "sport": 6.138,
    "market": 0.867,
    "stadium": 0.618,
    "brand": 0.377,
    "year": 2026,
    "month": 9,
    "revenue": 0.613,
    "operatingIncome": 0.071,
    "source": "Forbes nfl-valuations 2026",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "toronto-maple-leafs": {
    "total": 3.8,
    "sport": 0.169,
    "market": 1.851,
    "stadium": 1.185,
    "brand": 0.594,
    "year": 2024,
    "month": 12,
    "revenue": 0.308,
    "operatingIncome": 0.125,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": -0.0003,
    "sumOk": true,
    "componentsPublished": true
  },
  "new-york-rangers": {
    "total": 3.5,
    "sport": 0.219,
    "market": 1.76,
    "stadium": 1.005,
    "brand": 0.515,
    "year": 2024,
    "month": 12,
    "revenue": 0.315,
    "operatingIncome": 0.104,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": -0.0003,
    "sumOk": true,
    "componentsPublished": true
  },
  "montreal-canadiens": {
    "total": 3,
    "sport": 0.054,
    "market": 1.403,
    "stadium": 0.894,
    "brand": 0.65,
    "year": 2024,
    "month": 12,
    "revenue": 0.321,
    "operatingIncome": 0.142,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0.0003,
    "sumOk": true,
    "componentsPublished": true
  },
  "los-angeles-kings": {
    "total": 2.9,
    "sport": 0.099,
    "market": 1.199,
    "stadium": 1.209,
    "brand": 0.393,
    "year": 2024,
    "month": 12,
    "revenue": 0.344,
    "operatingIncome": 0.143,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "boston-bruins": {
    "total": 2.7,
    "sport": 0.32,
    "market": 1.169,
    "stadium": 0.835,
    "brand": 0.376,
    "year": 2024,
    "month": 12,
    "revenue": 0.268,
    "operatingIncome": 0.069,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "edmonton-oilers": {
    "total": 2.65,
    "sport": 0.203,
    "market": 1.193,
    "stadium": 0.844,
    "brand": 0.409,
    "year": 2024,
    "month": 12,
    "revenue": 0.388,
    "operatingIncome": 0.213,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": -0.0004,
    "sumOk": true,
    "componentsPublished": true
  },
  "chicago-blackhawks": {
    "total": 2.45,
    "sport": 0.299,
    "market": 1.038,
    "stadium": 0.82,
    "brand": 0.293,
    "year": 2024,
    "month": 12,
    "revenue": 0.26,
    "operatingIncome": 0.1,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "philadelphia-flyers": {
    "total": 2.3,
    "sport": 0.369,
    "market": 0.977,
    "stadium": 0.671,
    "brand": 0.283,
    "year": 2024,
    "month": 12,
    "revenue": 0.26,
    "operatingIncome": 0.071,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "washington-capitals": {
    "total": 2.15,
    "sport": 0.35,
    "market": 0.865,
    "stadium": 0.636,
    "brand": 0.3,
    "year": 2024,
    "month": 12,
    "revenue": 0.244,
    "operatingIncome": 0.081,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0.0005,
    "sumOk": true,
    "componentsPublished": true
  },
  "detroit-red-wings": {
    "total": 2.125,
    "sport": 0.499,
    "market": 0.819,
    "stadium": 0.513,
    "brand": 0.294,
    "year": 2024,
    "month": 12,
    "revenue": 0.229,
    "operatingIncome": 0.053,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "new-jersey-devils": {
    "total": 2.1,
    "sport": 0.268,
    "market": 0.794,
    "stadium": 0.781,
    "brand": 0.258,
    "year": 2024,
    "month": 12,
    "revenue": 0.265,
    "operatingIncome": 0.067,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0.0005,
    "sumOk": true,
    "componentsPublished": true
  },
  "dallas-stars": {
    "total": 2,
    "sport": 0.32,
    "market": 0.811,
    "stadium": 0.592,
    "brand": 0.276,
    "year": 2024,
    "month": 12,
    "revenue": 0.23,
    "operatingIncome": 0.059,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": -0.0005,
    "sumOk": true,
    "componentsPublished": true
  },
  "vancouver-canucks": {
    "total": 1.95,
    "sport": 0.412,
    "market": 0.816,
    "stadium": 0.46,
    "brand": 0.262,
    "year": 2024,
    "month": 12,
    "revenue": 0.226,
    "operatingIncome": 0.041,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "new-york-islanders": {
    "total": 1.9,
    "sport": 0.491,
    "market": 0.682,
    "stadium": 0.483,
    "brand": 0.245,
    "year": 2024,
    "month": 12,
    "revenue": 0.2,
    "operatingIncome": 0.029,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0.0005,
    "sumOk": true,
    "componentsPublished": true
  },
  "vegas-golden-knights": {
    "total": 1.85,
    "sport": 0.27,
    "market": 0.809,
    "stadium": 0.513,
    "brand": 0.258,
    "year": 2024,
    "month": 12,
    "revenue": 0.231,
    "operatingIncome": 0.059,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "tampa-bay-lightning": {
    "total": 1.8,
    "sport": 0.399,
    "market": 0.681,
    "stadium": 0.533,
    "brand": 0.187,
    "year": 2024,
    "month": 12,
    "revenue": 0.22,
    "operatingIncome": 0.044,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "pittsburgh-penguins": {
    "total": 1.75,
    "sport": 0.327,
    "market": 0.745,
    "stadium": 0.429,
    "brand": 0.25,
    "year": 2024,
    "month": 12,
    "revenue": 0.223,
    "operatingIncome": 0.052,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0.0006,
    "sumOk": true,
    "componentsPublished": true
  },
  "colorado-avalanche": {
    "total": 1.7,
    "sport": 0.478,
    "market": 0.581,
    "stadium": 0.446,
    "brand": 0.196,
    "year": 2024,
    "month": 12,
    "revenue": 0.198,
    "operatingIncome": 0.02,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0.0006,
    "sumOk": true,
    "componentsPublished": true
  },
  "calgary-flames": {
    "total": 1.65,
    "sport": 0.447,
    "market": 0.65,
    "stadium": 0.365,
    "brand": 0.187,
    "year": 2024,
    "month": 12,
    "revenue": 0.191,
    "operatingIncome": 0.037,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": -0.0006,
    "sumOk": true,
    "componentsPublished": true
  },
  "seattle-kraken": {
    "total": 1.6,
    "sport": 0.345,
    "market": 0.573,
    "stadium": 0.405,
    "brand": 0.278,
    "year": 2024,
    "month": 12,
    "revenue": 0.194,
    "operatingIncome": 0.022,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0.0006,
    "sumOk": true,
    "componentsPublished": true
  },
  "minnesota-wild": {
    "total": 1.55,
    "sport": 0.432,
    "market": 0.56,
    "stadium": 0.376,
    "brand": 0.181,
    "year": 2024,
    "month": 12,
    "revenue": 0.2,
    "operatingIncome": 0.033,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": -0.0006,
    "sumOk": true,
    "componentsPublished": true
  },
  "nashville-predators": {
    "total": 1.5,
    "sport": 0.413,
    "market": 0.474,
    "stadium": 0.443,
    "brand": 0.17,
    "year": 2024,
    "month": 12,
    "revenue": 0.195,
    "operatingIncome": 0.033,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "st-louis-blues": {
    "total": 1.45,
    "sport": 0.383,
    "market": 0.523,
    "stadium": 0.36,
    "brand": 0.185,
    "year": 2024,
    "month": 12,
    "revenue": 0.192,
    "operatingIncome": 0.0095,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0.0007,
    "sumOk": true,
    "componentsPublished": true
  },
  "florida-panthers": {
    "total": 1.4,
    "sport": 0.435,
    "market": 0.439,
    "stadium": 0.346,
    "brand": 0.179,
    "year": 2024,
    "month": 12,
    "revenue": 0.189,
    "operatingIncome": 0.01,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": -0.0007,
    "sumOk": true,
    "componentsPublished": true
  },
  "san-jose-sharks": {
    "total": 1.35,
    "sport": 0.54,
    "market": 0.386,
    "stadium": 0.322,
    "brand": 0.102,
    "year": 2024,
    "month": 12,
    "revenue": 0.169,
    "operatingIncome": 0.0019,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "anaheim-ducks": {
    "total": 1.3,
    "sport": 0.459,
    "market": 0.412,
    "stadium": 0.277,
    "brand": 0.152,
    "year": 2024,
    "month": 12,
    "revenue": 0.175,
    "operatingIncome": 0.015,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "carolina-hurricanes": {
    "total": 1.25,
    "sport": 0.395,
    "market": 0.414,
    "stadium": 0.299,
    "brand": 0.142,
    "year": 2024,
    "month": 12,
    "revenue": 0.183,
    "operatingIncome": 0.023,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0,
    "sumOk": true,
    "componentsPublished": true
  },
  "utah-hockey-club": {
    "total": 1.2,
    "sport": 0.747,
    "market": 0.264,
    "stadium": 0.107,
    "brand": 0.081,
    "year": 2024,
    "month": 12,
    "revenue": 0.123,
    "operatingIncome": -0.004,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": -0.0008,
    "sumOk": true,
    "componentsPublished": true
  },
  "ottawa-senators": {
    "total": 1.15,
    "sport": 0.438,
    "market": 0.378,
    "stadium": 0.221,
    "brand": 0.112,
    "year": 2024,
    "month": 12,
    "revenue": 0.154,
    "operatingIncome": 0.0044,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": -0.0009,
    "sumOk": true,
    "componentsPublished": true
  },
  "buffalo-sabres": {
    "total": 1.1,
    "sport": 0.42,
    "market": 0.36,
    "stadium": 0.218,
    "brand": 0.101,
    "year": 2024,
    "month": 12,
    "revenue": 0.169,
    "operatingIncome": 0.013,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": -0.0009,
    "sumOk": true,
    "componentsPublished": true
  },
  "winnipeg-jets": {
    "total": 1.05,
    "sport": 0.376,
    "market": 0.349,
    "stadium": 0.22,
    "brand": 0.106,
    "year": 2024,
    "month": 12,
    "revenue": 0.17,
    "operatingIncome": 0.009300000000000001,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0.001,
    "sumOk": true,
    "componentsPublished": true
  },
  "columbus-blue-jackets": {
    "total": 1,
    "sport": 0.411,
    "market": 0.31,
    "stadium": 0.178,
    "brand": 0.102,
    "year": 2024,
    "month": 12,
    "revenue": 0.15,
    "operatingIncome": 0.0012,
    "source": "Forbes nhl-valuations 2024",
    "sumCheck": 0.001,
    "sumOk": true,
    "componentsPublished": true
  },
  "manchester-united": {
    "total": 7.2,
    "sport": null,
    "market": null,
    "stadium": null,
    "brand": null,
    "year": 2026,
    "month": 5,
    "revenue": 0.865,
    "operatingIncome": 0.237,
    "source": "Forbes soccer-valuations 2026",
    "sumCheck": null,
    "sumOk": null,
    "componentsPublished": false
  },
  "liverpool": {
    "total": 6.2,
    "sport": null,
    "market": null,
    "stadium": null,
    "brand": null,
    "year": 2026,
    "month": 5,
    "revenue": 0.911,
    "operatingIncome": 0.133,
    "source": "Forbes soccer-valuations 2026",
    "sumCheck": null,
    "sumOk": null,
    "componentsPublished": false
  },
  "manchester-city": {
    "total": 5.5,
    "sport": null,
    "market": null,
    "stadium": null,
    "brand": null,
    "year": 2026,
    "month": 5,
    "revenue": 0.9,
    "operatingIncome": 0.115,
    "source": "Forbes soccer-valuations 2026",
    "sumCheck": null,
    "sumOk": null,
    "componentsPublished": false
  },
  "arsenal": {
    "total": 5.4,
    "sport": null,
    "market": null,
    "stadium": null,
    "brand": null,
    "year": 2026,
    "month": 5,
    "revenue": 0.895,
    "operatingIncome": 0.185,
    "source": "Forbes soccer-valuations 2026",
    "sumCheck": null,
    "sumOk": null,
    "componentsPublished": false
  },
  "chelsea": {
    "total": 4.2,
    "sport": null,
    "market": null,
    "stadium": null,
    "brand": null,
    "year": 2026,
    "month": 5,
    "revenue": 0.637,
    "operatingIncome": -0.026,
    "source": "Forbes soccer-valuations 2026",
    "sumCheck": null,
    "sumOk": null,
    "componentsPublished": false
  },
  "tottenham-hotspur": {
    "total": 3,
    "sport": null,
    "market": null,
    "stadium": null,
    "brand": null,
    "year": 2026,
    "month": 5,
    "revenue": 0.733,
    "operatingIncome": 0.139,
    "source": "Forbes soccer-valuations 2026",
    "sumCheck": null,
    "sumOk": null,
    "componentsPublished": false
  },
  "aston-villa": {
    "total": 1.4,
    "sport": null,
    "market": null,
    "stadium": null,
    "brand": null,
    "year": 2026,
    "month": 5,
    "revenue": 0.49,
    "operatingIncome": -0.03,
    "source": "Forbes soccer-valuations 2026",
    "sumCheck": null,
    "sumOk": null,
    "componentsPublished": false
  },
  "newcastle-united": {
    "total": 1.25,
    "sport": null,
    "market": null,
    "stadium": null,
    "brand": null,
    "year": 2026,
    "month": 5,
    "revenue": 0.435,
    "operatingIncome": -0.002,
    "source": "Forbes soccer-valuations 2026",
    "sumCheck": null,
    "sumOk": null,
    "componentsPublished": false
  },
  "everton": {
    "total": 0.93,
    "sport": null,
    "market": null,
    "stadium": null,
    "brand": null,
    "year": 2026,
    "month": 5,
    "revenue": 0.255,
    "operatingIncome": -0.015,
    "source": "Forbes soccer-valuations 2026",
    "sumCheck": null,
    "sumOk": null,
    "componentsPublished": false
  },
  "fulham": {
    "total": 0.92,
    "sport": null,
    "market": null,
    "stadium": null,
    "brand": null,
    "year": 2026,
    "month": 5,
    "revenue": 0.253,
    "operatingIncome": -0.025,
    "source": "Forbes soccer-valuations 2026",
    "sumCheck": null,
    "sumOk": null,
    "componentsPublished": false
  },
  "brighton-and-hove-albion": {
    "total": 0.91,
    "sport": null,
    "market": null,
    "stadium": null,
    "brand": null,
    "year": 2026,
    "month": 5,
    "revenue": 0.295,
    "operatingIncome": -0.015,
    "source": "Forbes soccer-valuations 2026",
    "sumCheck": null,
    "sumOk": null,
    "componentsPublished": false
  }
}
